<template>
  <div class="prh-my-course bg-white" v-if="coursesList && coursesList.length>0">
    <div class=" pr-3 bg-white d-flex align-items-center justify-content-between">
      <span class="d-block b-title bg-white d-flex align-items-center">我的课程</span>
      <a class="more font-weight-normal" href="#">查看全部></a>
    </div>
    <div class="course-list list">
      <row-card-component typeBlock="sub-course" :cardList="coursesList"></row-card-component>
    </div>
  </div>
</template>

<script>

  import RowCardComponent from "@/components/rowCardComponent";

  export default {
    name: "subMyCourse",
    components: {
      RowCardComponent
    },
    props: [
      'coursesList',
    ],
  }
</script>

<style>


  .my-course-card .van-card__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .prh-my-course .my-course-card .van-card__bottom p {
    margin-bottom: 0 !important;
  }


</style>
